'use client';

import { useMemo } from 'react';
import TermFacetItem from './TermFacetItem';
import { FacetProps } from './types';
import { useProductList } from '../../context';
import { TermFacet as TermFacetType } from '../../types';

const TermFacet: React.FC<FacetProps> = ({ attribute }) => {
  const { facetsConfiguration } = useProductList();

  const facet = useMemo(() => facetsConfiguration[attribute] as TermFacetType, [facetsConfiguration, attribute]);

  return (
    <div className="flex flex-col gap-3 lg:min-w-[340px]">
      {facet.terms.map((term) => (
        <TermFacetItem key={term.identifier} attribute={attribute} term={term} />
      ))}
    </div>
  );
};

export default TermFacet;
